import { httpClient } from "../utilities/HttpHelper"
import { apiHost } from "../constants/api"

export const getUserResource = async (code) => {
    let fetchUrl = `${apiHost}/login?code=${code}`
    let response = await httpClient.get(fetchUrl)
    if(response.status === 200) {
        return response.data
    }
    return []
}

export const setUserResource = async (resource) => {
    localStorage.setItem('login-status', 'SIGN-IN')
    localStorage.setItem('role', resource.role)
    localStorage.setItem('username', resource.username)
}

export const getResource = async (field) => {
    return localStorage.getItem(field)
}

export const logOut = async () => {
    localStorage.setItem('login-status', null)
    localStorage.setItem('role', null)
    localStorage.setItem('username', null)
    window.location.href = `${process.env.REACT_APP_BASE_PATH}`
}

export const isStaff = async () => {
    let role = await getResource('role')
    let username = await getResource('username')
    let _isStaff = ['Admin', 'Staff', 'Manager'].includes(role)
    return _isStaff
}